import { type SpacingValue, SPACING_VALUE } from '../../common/sizing';
import { spacings } from '../../stitches.config';

export function isSpacingValue(value: number): value is SpacingValue {
  return (SPACING_VALUE as readonly number[]).includes(value);
}

export type SizerProp = SpacingValue;
export const sizer = (value: SizerProp) => spacings[value];

export type SpacingScale = SpacingValue;
export type SizingScale =
  | 'auto'
  | 'fit-content'
  | 'full'
  | 'max-content'
  | 'min-content'
  | 'screen'
  | SpacingScale;

/**
 * @deprecated This does nothing, just here for migration reasons.
 */
export function space(size: SpacingValue): SpacingValue {
  return size;
}
